import loadable from '@loadable/component';

export const CreativebloqSiteWrapper = loadable(
  () => import(/* webpackChunkName: "creativebloq-site" */ './CreativebloqSiteWrapper'),
);
